import "core-js/modules/es.array.filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Storage from '@tencent/vft-common/Storage';
var SAVE_KEY = 'ysf_live_show_time';
export default {
  props: {
    liveInfo: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('input', false);
      this.$emit('close');
    }
  },
  created: function created() {
    var now = this.now;
    var time = Storage.get(SAVE_KEY);

    if (time && +time + 10 * 60 * 1000 > now) {
      return;
    }

    var list = this.setting.演出场次.filter(function (v) {
      return v.开始时间 <= now && now <= v.结束时间;
    });

    if (list.length > 0) {
      var item = list[0];
      this.eventBus.$emit('showLivePop', item);
      Storage.set(SAVE_KEY, Date.now());
    }
  }
};